import * as React from 'react';

import { IJsonLdSchemas } from './type';

export const JsonLdSchema = (props: IJsonLdSchemas) => {
	const {
		id,
		schema,
	} = props;

	return <script
		key={`jobJSON-${id}`}
		type='application/ld+json'
		dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
	/>;
};
